module.exports = __webpack_public_path__ + "img/cartopview.2c61fdad.png";